// extracted by mini-css-extract-plugin
export var linkText = "_nl-0";